import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_ACTIVO = 'Activo';
export const STATE_BAJA = 'Baja';
export const STATE_TRASPASADO = 'Traspasado';
export const STATE_BORRRADOR = 'Borrador';
export const STATE_SOLICITUD = 'Solicitud';

// Definición del enum
export const statesEntity = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un estado',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ACTIVO,
        label: 'Activo',
        description: 'Estado Activo',
        icon: IconSelector.DoIcon,
        color: 'Green'
    },
    {
        value: STATE_BAJA,
        label: 'Baja',
        description: 'Estado Baja',
        icon: IconSelector.DoneIcon,
        color: 'DarkRed'
    },
    {
        value: STATE_TRASPASADO,
        label: 'Traspasado',
        description: 'Estado Traspasado',
        icon: IconSelector.TransferredIcon,
        color: 'Black'
    },
    {
        value: STATE_BORRRADOR,
        label: 'Borrador',
        description: 'Estado Borrador',
        icon: IconSelector.DraftIcon,
        color: 'DarkOrange'
    },
    {
        value: STATE_SOLICITUD,
        label: 'Solicitud',
        description: 'Estado Solicitud',
        icon: IconSelector.SolicitudesIcon,
        color: 'Blue'
    }
];
